import cls from "./banner.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Banner } from "interfaces";
import BannerSingle from "components/bannerSingle/bannerSingle";
import {
  NextButton,
  PrevButton,
} from "components/carouselArrows/carouselArrows";
import { Skeleton } from "@mui/material";
import "swiper/css";

type BannerProps = {
  banners: Banner[];
  loadingBanner: boolean;
};

export default function BannerContainer({
  banners,
  loadingBanner,
}: BannerProps) {
  return (
    <div className={cls.container}>
      <div className={cls.banner}>
        <div className={cls.bannerContainer}>
          {!loadingBanner ? (
            <Swiper spaceBetween={10} slidesPerView={1}>
              {banners.map((item) => (
                <SwiperSlide key={item.id}>
                  <BannerSingle data={item} />
                </SwiperSlide>
              ))}
              {banners.length > 2 && (
                <>
                  <PrevButton />
                  <NextButton />
                </>
              )}
            </Swiper>
          ) : (
            <div className={cls.shimmerContainer}>
              {Array.from(new Array(1)).map((_, idx) => (
                <Skeleton
                  key={"banner" + idx}
                  variant="rectangular"
                  className={cls.shimmer}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
